import React, { useState } from "react";
import {
  Box,
  Divider,
  Flex,
  SimpleGrid,
  Text,
  useDisclosure
} from "@chakra-ui/react";
import { Form, TextInput } from "components";
import { useCurrentCase } from "duck";
import { SpeciesEnum } from "requests";
import { useUpdateGeneralAssessment } from "../../../../duck";
import { SelectionModal } from "./components";
import {
  BONE_LOSS_OPTIONS,
  DENTAL_RADIOLOGY_OPTIONS,
  FormValues,
  getDefaultValues,
  OTHER_OPTIONS,
  TOOTH_RESORPTION_OPTIONS
} from "./duck";

const leftLabelledInputProps = {
  display: "flex",
  alignItems: "end"
};

const BoneLoss: React.FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [clickedInputName, setClickedInputName] = useState<
    keyof FormValues | null
  >(null);

  const { species, genAssessment } = useCurrentCase(medCase => ({
    species: medCase.data.client.patient.species || null,
    genAssessment: medCase.data.client.patient.generalAssessment
  }));

  const defaultValues = getDefaultValues(genAssessment);

  const handleClick = (e: React.MouseEvent) => {
    setClickedInputName(e.target.name as keyof FormValues);
    onOpen();
  };

  const handleChange = useUpdateGeneralAssessment();

  if (!defaultValues) {
    return null;
  }

  return (
    <Form<FormValues> defaultValues={defaultValues}>
      <Form.Watcher defaultValues={defaultValues} onChange={handleChange} />
      <Flex mt={6} direction="column" rowGap="6">
        <Box>
          <Text mb={4} fontWeight="semibold" color="gray.600">
            Bone Loss
          </Text>
          <Flex direction="column" rowGap="6">
            {BONE_LOSS_OPTIONS.map(opt => (
              <TextInput
                name={opt.name}
                key={opt.name}
                label={opt.label}
                placeholder="Click to select affected teeth"
                isReadOnly
                onClick={handleClick}
              />
            ))}
          </Flex>
        </Box>

        <Divider h="1px" borderColor="#D0D1D3" />

        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6}>
          {OTHER_OPTIONS.map(opt => (
            <TextInput
              key={opt.name}
              name={opt.name}
              label={opt.label}
              placeholder="Click to select affected teeth"
              isReadOnly
              onClick={handleClick}
            />
          ))}
        </SimpleGrid>

        <Divider h="1px" borderColor="#D0D1D3" />

        {species === SpeciesEnum.Cat && (
          <Box>
            <Text mb={4} fontWeight="semibold" color="gray.600">
              Tooth Resorption
            </Text>
            <Flex direction="column" rowGap={6}>
              {TOOTH_RESORPTION_OPTIONS.map(opt => (
                <TextInput
                  name={opt.name}
                  key={opt.name}
                  label={opt.label}
                  placeholder="Click to select affected teeth"
                  inputLayoutProps={leftLabelledInputProps}
                  isReadOnly
                  onClick={handleClick}
                />
              ))}
            </Flex>
            <Divider mt={6} h="1px" borderColor="#D0D1D3" />
          </Box>
        )}

        <Flex direction="column" rowGap={6}>
          {DENTAL_RADIOLOGY_OPTIONS.map(opt => (
            <TextInput
              key={opt.name}
              name={opt.name}
              label={opt.label}
              placeholder="Click to select affected teeth"
              inputLayoutProps={leftLabelledInputProps}
              isReadOnly
              onClick={handleClick}
            />
          ))}
        </Flex>

        {clickedInputName && (
          <SelectionModal
            onClose={onClose}
            isOpen={isOpen}
            fieldName={clickedInputName}
          />
        )}
      </Flex>
    </Form>
  );
};

export default BoneLoss;
